import { ReactElement, ReactNode } from "react";
import { Text } from "@mantine/core";
import { IErrorMessageProps } from "./types";
import { getContent } from "./utils";

export default function ErrorMessage({
  error,
  ...textProps
}: IErrorMessageProps): ReactElement | null {
  const content: ReactNode = getContent(error);
  if (!content) {
    return null;
  }

  return (
    <Text c="red.2" fz="sm" {...textProps}>
      {content}
    </Text>
  );
}
